import styled from '@emotion/styled';
import { Switch, Typography } from '@material-ui/core';
import { ChangeEvent, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

interface Props {
  onChangeEvent: (e: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  isHideClosedOffer: boolean;
  messageId: string;
  isDisabled: boolean;
}

export const OfferListSwitch = ({ onChangeEvent, isHideClosedOffer, messageId, isDisabled }: Props) => {
  return (
    <Root>
      <Switch onChange={onChangeEvent} checked={isHideClosedOffer} disabled={isDisabled} />
      <Typography>
        <FormattedMessage id={messageId} />
      </Typography>
    </Root>
  );
};

const Root = styled('div')(flexibleLayoutContainer({ direction: 'row', alignItems: 'center' }), {
  padding: SPACING_UNIT,
});
